module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av141-9f7b545bfd4384d4ec2db35751a67937.jpg";